import { useEffect, useState } from 'react'
import { List, Button, Layout, Tabs } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import Feather from '@sysunite/react-feather'
import { MergeRequest } from 'Model'
import moment from 'moment'
import WeaverService from 'Services/WeaverService'

{ TabPane } = Tabs

export default ->

  [mergeRequests, setMergeRequests] = useState([])
  [status, setStatus] = useState('open')
  [loading, setLoading] = useState(true)
  { pathname } = useLocation()

  createNewButton =
    <Link to="#{pathname}/new">
      <Button
        type="primary"
        data-testid="new-merge-request"
      >
        New merge request
      </Button>
    </Link>

  useEffect(->
    (->
      setLoading(true)
      switch status
        when 'open'
          mrs = await MergeRequest.getOpen()
        when 'closed'
          mrs = await MergeRequest.getClosed()
        when 'merged'
          mrs = await MergeRequest.getMerged()

      setMergeRequests(mrs)
      setLoading(false)
    )()
    undefined
  , [status])

  getUserById = (id) ->
    user = WeaverService.currentProjectUsers[id]
    "#{user?.firstname} #{user?.lastname}"

  <Layout>
    <Tabs
      tabBarExtraContent={{
        left: <h3 style={{ margin: 0 }}>Merge requests</h3>
        right: createNewButton
      }}
      activeKey={status}
      onChange={setStatus}
      tabBarStyle={{ padding: '0px 16px', margin: 0 }}
      style={{ background: 'inherit' }}
      centered
    >
      <TabPane tab="Open" key="open" />
      <TabPane tab="Merged" key="merged" />
      <TabPane tab="Closed" key="closed" />
    </Tabs>
    <div style={{ padding: '0px 16px' }}>
      <List
        dataSource={mergeRequests}
        loading={loading}
        renderItem={(mr) ->
          <List.Item>
            <List.Item.Meta
              title={<Link to="#{pathname}/#{mr.id()}">{ mr.get('title') }</Link>}
              description={
                <span>{mr.id()} · created at {moment(mr.createdAt()).fromNow()} by {getUserById(mr.createdBy())} · <b><Feather type="git-branch" /> {mr.get('source')}</b></span>
              }
            />
          </List.Item>
        }
      />
    </div>
  </Layout>
